<script setup>
import { faAngleDown, faLanguage } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useI18n } from 'petite-vue-i18n'
import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { isDescendantOrSelf } from '../../../util/dom'
import { getUniqueElementId } from '../../../util/id'

const { locale } = useI18n()

defineProps({
  hideLabel: { type: Boolean, default: false }
})

const dropdownElementId = ref(getUniqueElementId())
const isActive = ref(false)
const options = ref([
  { value: 'de-CH', label: 'Deutsch (CH)' },
  { value: 'de-DE', label: 'Deutsch (DE)' },
  { value: 'nl', label: 'Nederlands (NL)' }
])

const triggerLabel = computed(() => options.value.find(o => o.value === locale.value)?.label ?? '')

function clickHandler(e) {
  if (!isDescendantOrSelf(e.target, document.getElementById(dropdownElementId.value))) {
    isActive.value = false // deactivate dropdown when clicking outside it
  }
}

function onSelect(value) {
  locale.value = value
  isActive.value = false
}

watch(
  () => isActive.value,
  active => {
    if (active) {
      window.addEventListener('click', clickHandler)
    } else {
      window.removeEventListener('click', clickHandler)
    }
  }
)

onBeforeUnmount(() => {
  window.removeEventListener('click', clickHandler)
})
</script>

<template>
  <div :id="dropdownElementId" class="dropdown" :class="{ 'is-active': isActive }">
    <div class="dropdown-trigger">
      <button
        class="button is-outlined is-link"
        type="button"
        aria-haspopup="true"
        aria-controls="dropdown-menu"
        @click="isActive = !isActive"
      >
        <span class="icon is-small"><FontAwesomeIcon :icon="faLanguage" /></span>
        <span v-if="!hideLabel">{{ triggerLabel }}</span>
        <span class="icon is-small"><FontAwesomeIcon :icon="faAngleDown" /></span>
      </button>
    </div>
    <div class="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <button
          type="button"
          v-for="option of options"
          :key="option.value"
          class="dropdown-item"
          :class="{ 'is-active': locale === option.value }"
          @click="onSelect(option.value)"
        >
          {{ option.label }}
        </button>
      </div>
    </div>
  </div>
</template>
